<form [formGroup]="formulario" (ngSubmit)="guardar()" [ngClass]="{ disabledContent: disabledContent }">
  <div class="row">
    <div class="col">
      <h5 class="modal-title w-100 text-left" id="myModalLabel">Datos del producto</h5>
    </div>
    <div class="col">
      <div class="switch info-switch">
        <label>Inactivo<input type="checkbox" formControlName="activo" color="info" checked
            (change)="toggleCheckbox($event)" /><span class="lever"></span>Activo</label>
      </div>
    </div>
  </div>
  <div class="row">
    <!-- Left -->
    <div class="col">
      <div class="row">
        <div class="col">
          <div class="md-form mb-1">
            <input value="" formControlName="sku" type="text" id="asku" class="form-control" placeholder="SKU" #sku />
            <label for="sku"> SKU <app-required-field></app-required-field> </label>
            <div
              *ngIf="formulario.get('sku').invalid && (formulario.get('sku').dirty || formulario.get('sku').touched)">
              <mdb-error *ngIf="formulario.get('sku').hasError('required')">El SKU es requerido.</mdb-error>
              <mdb-error *ngIf="formulario.get('sku').hasError('maxlength')">El SKU no puede superar los 50
                caracteres.</mdb-error>
              <mdb-error *ngIf="formulario.get('sku').hasError('minlength')">El SKU debe tener como mínimo 2
                caracteres.</mdb-error>
            </div>
          </div>
        </div>
        <div class="col">
          <!--Rounded checkbox buttons-->
          <div class="btn-group">
            <label mdbBtn color="warning" rounded="true" class="active form-check-label favorito"
              formControlName="favorito" mdbCheckbox mdbWavesEffect>
              <mdb-icon fas icon="star"></mdb-icon>
            </label>
          </div>
          <!--Rounded checkbox buttons-->
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="md-form">
            <input value="" formControlName="codigo_barras" type="text" id="acodigo" class="form-control"
              placeholder="Código de barra" #codigo />
            <label for="codigo">Código de barra</label>
            <div
              *ngIf="formulario.get('codigo_barras').invalid && (formulario.get('codigo_barras').dirty || formulario.get('codigo_barras').touched)">
              <mdb-error *ngIf="formulario.get('codigo_barras').hasError('required')">El Codigo de barra es
                requerido.</mdb-error>
              <mdb-error *ngIf="formulario.get('codigo_barras').hasError('maxlength')">El Codigo de barra no puede
                superar los 50 caracteres.</mdb-error>
              <mdb-error *ngIf="formulario.get('codigo_barras').hasError('minlength')">El Codigo de barra debe tener
                como mínimo 5 caracteres.</mdb-error>
            </div>
          </div>
          <div class="md-form">
            <input value="" formControlName="descripcion" type="text" id="adescripcion" class="form-control"
              placeholder="Descripción" #descripcion />
            <label for="descripcion"> Descripción <app-required-field></app-required-field> </label>
            <div
              *ngIf="formulario.get('descripcion').invalid && (formulario.get('descripcion').dirty || formulario.get('descripcion').touched)">
              <mdb-error *ngIf="formulario.get('descripcion').hasError('required')">La Descripción es
                requerido.</mdb-error>
              <mdb-error *ngIf="formulario.get('descripcion').hasError('maxlength')">La Descripción no puede superar los
                50 caracteres.</mdb-error>
              <mdb-error *ngIf="formulario.get('descripcion').hasError('minlength')">La Descripción debe tener como
                mínimo 5 caracteres.</mdb-error>
            </div>
          </div>
          <div class="md-form">
            <input value="" formControlName="descripcion_ext" type="text" id="amarca" class="form-control"
              placeholder="Marca" #marca />
            <label for="marca">Marca</label>
          </div>
          <div class="md-form">
            <mdb-select label="Unidad" [options]="optionsUnidadMedida" formControlName="unidad_medida_codigo"
              placeholder="Unidad Medida"> </mdb-select>
          </div>
          <div class="md-form" *ngIf="parametroSeguimiento">
            <mdb-checkbox formControlName="seguimiento" (change)="OnchangeSeguimiento($event)">Cobertura
            </mdb-checkbox>
          </div>
        </div>
      </div>
    </div>

    <!-- Right -->
    <div class="col">
      <strong *ngIf="mode === 'EDIT'">Fecha de creación: </strong>
      <span>{{ fecha_registro | fecha }}</span>

      <div class="md-form">
        <mdb-select label="Rubro" [options]="optionsRubro" formControlName="rubro_codigo" placeholder="Rubro">
        </mdb-select>
        <div
          *ngIf="formulario.get('rubro_codigo').invalid && (formulario.get('rubro_codigo').dirty || formulario.get('rubro_codigo').touched)">
          <mdb-error *ngIf="formulario.get('rubro_codigo').hasError('required')">El Rubro es requerido.</mdb-error>
        </div>
      </div>

      <div class="md-form">
        <mdb-select label="Familia" [options]="optionsFamiliaRubros" formControlName="familia_codigo"
          placeholder="Familia"></mdb-select>
        <div
          *ngIf="formulario.get('familia_codigo').invalid && (formulario.get('familia_codigo').dirty || formulario.get('familia_codigo').touched)">
          <mdb-error *ngIf="formulario.get('familia_codigo').hasError('required')">La Familia es requerido.</mdb-error>
        </div>
      </div>

      <div class="md-form" *ngIf="parametroNegocio">
        <mdb-select label="Unidad Negocio" [options]="optionsUnidadNegocio" formControlName="unidad_negocio_codigo"
          placeholder="Unidad Negocio"></mdb-select>
        <div
          *ngIf="formulario.get('unidad_negocio_codigo').invalid && (formulario.get('unidad_negocio_codigo').dirty || formulario.get('unidad_negocio_codigo').touched)">
          <mdb-error *ngIf="formulario.get('unidad_negocio_codigo').hasError('required')">La Unidad de Negocio es
            requerido.</mdb-error>
        </div>
      </div>

      <div class="md-form">
        Seleccionar impuesto adicional
        <button type="button" size="sm" mdbBtn color="info" (click)="showModalImpuestos()" mdbWavesEffect>...</button>
      </div>

      <div class="md-form">
        <mdb-checkbox *ngIf="mode == 'ADD' && canEditExcentoIVA" formControlName="es_exento">Exento de IVA
        </mdb-checkbox>
        <mdb-checkbox *ngIf="mode == 'EDIT' && canEditExcentoIVA" [checked]="true" formControlName="es_exento"> Exento
          de IVA</mdb-checkbox>
        <mdb-checkbox formControlName="afecto_reglas_comerciales">No afecto a reglas comerciales </mdb-checkbox>
        <mdb-checkbox formControlName="no_aplica_descuento">No aplica descuento global</mdb-checkbox>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col" style="min-width: 20%">
      <div class="md-form">
        <input formControlName="formato_combinacion1" value="" type="number" id="apeso" class="form-control" step="0"
          placeholder="0" #peso />
        <label for="codigoBarra">{{ formatoNombreComb1 }}</label>
      </div>
    </div>
    <div class="col" style="min-width: 20%">
      <div class="md-form">
        <input formControlName="formato_combinacion2" value="" type="number" id="avolumen" class="form-control" step="0"
          placeholder="0" #volumen />
        <label for="codigoBarra"> {{ formatoNombreComb2 }} </label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col" style="min-width: 35%">
      <div class="md-form">
        <mdb-select formControlName="formato" label="Seleccionar Formato" [options]="optionsFormato"
          placeholder="Formato"></mdb-select>
      </div>
    </div>
    <div class="col" style="min-width: 20%">
      <div class="md-form">
        <input formControlName="peso" value="" type="number" id="apeso" class="form-control" step="0,1"
          placeholder="0,00" #peso />
        <label for="codigoBarra"> Peso Neto(Kgs.) </label>
      </div>
    </div>
    <div class="col" style="min-width: 20%">
      <div class="md-form">
        <input formControlName="volumen" value="" type="number" id="avolumen" class="form-control" step="0,1"
          placeholder="0,00" #volumen />
        <label for="codigoBarra"> Volumen(m3) </label>
      </div>
    </div>
    <div class="col">
      <button *ngIf="mode == 'ADD'" type="button" class="float-right" mdbBtn (click)="agregarFormatos()" color="info"
        class="btn btn-sm" size="sm" mdbWavesEffect>Agregar</button>
      <button *ngIf="mode == 'EDIT'" type="button" class="btn btn-sm float-right" size="sm" mdbBtn color="info"
        (click)="editarFormatos()" mdbWavesEffect>Agregar</button>
    </div>
  </div>

  <table class="table table-striped table-hover table-sm align-middle">
    <thead class="grey lighten-2">
      <tr>
        <th scope="col">Cod. Form</th>
        <th scope="col">Formato</th>
        <th scope="col">Peso (Kg)</th>
        <th scope="col">Volumen</th>
        <th scope="col">Factor</th>
        <th scope="col" class="text-center">Formato Princ.</th>
        <th scope="col" class="text-center">Formato Sec.</th>
        <th scope="col">Estado</th>
        <th scope="col"></th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="!listaProductoFormato || listaProductoFormato.length === 0">
        <td colspan="8" style="text-align: center">Agregue formato</td>
      </tr>
      <tr *ngFor="let pro_for of listaProductoFormato; let i = index">
        <td>{{ pro_for.formato_codigo }}</td>
        <td>{{ pro_for.formato_nombre }}</td>
        <td>{{ pro_for.peso_neto }}</td>
        <td>{{ pro_for.volumen }}</td>
        <td>{{ pro_for.cantidad }}</td>
        <td class="text-center">
          <div class="form-check align-items-center">
            <input type="radio" class="form-check-input" id="{{ pro_for.formato_codigo }}" *ngIf="pro_for.activo"
              name="groupOfRadioGap" [checked]="pro_for.formato_codigo_top == pro_for.formato_codigo"
              [value]="pro_for.formato_codigo" (change)="handleChangeAgregar(pro_for)" mdbInput />
            <label class="form-check-label" for="{{ pro_for.formato_codigo }}"></label>
          </div>
        </td>
        <td class="text-center">
          <div class="form-check align-items-center">
            <input type="radio" class="form-check-input" id="Product - {{ pro_for.formato_codigo2 }}"
              *ngIf="pro_for.activo" name="groupOfRadioGap - {{ pro_for.formato_codigo2 }}"
              [checked]="pro_for.formato_secundario == pro_for.formato_codigo2" [value]="pro_for.formato_codigo2"
              (change)="handleChangeAgregarSecundario(pro_for)" mdbInput />
            <label class="form-check-label" for="Product - {{ pro_for.formato_codigo2 }}"></label>
          </div>
        </td>
        <td>
          <div *ngIf="pro_for.activo">
            <mdb-badge pill="true" success="true">Activo</mdb-badge>
          </div>
          <div *ngIf="!pro_for.activo">
            <mdb-badge pill="true" warning="true">Inactivo</mdb-badge>
          </div>
        </td>
        <td>
          <button *ngIf="!pro_for.activo" class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect
            (click)="cambiarEstado(pro_for)" mdbTooltip="Activar" placement="right">
            <mdb-icon fas icon="ban"></mdb-icon>
          </button>
          <button *ngIf="pro_for.activo" class="btn-actions-sm" color="success" mdbBtn type="button" mdbWavesEffect
            (click)="cambiarEstado(pro_for)" mdbTooltip="Desactivar" placement="right">
            <mdb-icon fas icon="check"></mdb-icon>
          </button>
        </td>
        <td class="text-center">
          <button *ngIf="mode == 'ADD'" mdbBtn type="button" size="sm" color="primary" mdbWavesEffect
            class="btn-actions-sm" mdbTooltip="Eliminar" (click)="eliminarFormatoAgregados(i)">
            <mdb-icon fas icon="trash"></mdb-icon>
          </button>
          <button *ngIf="mode == 'EDIT'" mdbBtn type="button" size="sm" color="info" mdbWavesEffect
            class="btn-actions-sm" (click)="showEditarPesoVolumen(pro_for)" mdbTooltip="Editar" placement="right">
            <mdb-icon fas icon="pen"></mdb-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</form>

<!-- MODAL seleccionImpuesto -->
<app-producto-modal-seleccionar-impuesto (onImpuestoSeleccionado)="capturaImpuesto($event)">
</app-producto-modal-seleccionar-impuesto>

<!--Editar Volumen y peso-->
<app-producto-modal-volumen-peso (onVolumenPesoSeleccionado)="onVolumenPesoSeleccionado($event)">
</app-producto-modal-volumen-peso>

<app-modal-confirm></app-modal-confirm>

<app-modal-ver-errores></app-modal-ver-errores>
